export default __webpack_public_path__ + "static/media/DokumentuTvarkymas.fb6881ca.svg";